import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import NoSdgs from "sdgselection/components/NoSdgs";
import { UserSDG } from "sdgselection/types/SDG";
import "./styles/user-sdg-select.css";

interface UserSdgSelectProps {
  userSdgList: UserSDG[];
  selectedUserSdg: UserSDG | undefined;
  setUserSdgId: (id: string | null) => void;
}

const UserSdgSelect: React.FC<UserSdgSelectProps> = ({
  userSdgList,
  selectedUserSdg,
  setUserSdgId,
}) => {
  const hasSdgs = userSdgList && userSdgList.length > 0;

  if (!hasSdgs) {
    return (
      <div className="sdg-select-wrapper">
        <div className="sdg-select-card sdg-select-card--empty">
          <NoSdgs
            warningText={
              <>
                No SDG goals have been set yet.{" "}
                <Link to="/sdgselected" className="sdg-select__link">
                  Click here
                </Link>{" "}
                to configure your SDG focus first.
              </>
            }
          />
        </div>
      </div>
    );
  }

  return (
    <div className="sdg-select-wrapper">
      <div className="sdg-select-card">
        <header className="sdg-select-header">
          <h3 className="sdg-select-title">Select SDG focus</h3>
          <p className="sdg-select-subtitle">
            Choose the Sustainable Development Goal you want to work with for this action.
          </p>
        </header>

        <div className="sdg-select-control">
          <Select
            options={userSdgList.map((item) => ({
              value: item._id,
              label: item.title || `SDG ${item._id}`,
            }))}
            isSearchable
            placeholder="Search and select an SDG goal..."
            value={
              selectedUserSdg
                ? {
                    value: selectedUserSdg._id,
                    label:
                      selectedUserSdg.title || `SDG ${selectedUserSdg._id}`,
                  }
                : null
            }
            onChange={(option: any) => setUserSdgId(option ? option.value : null)}
            className="sdg-select"
            classNamePrefix="sdg-select"
          />
        </div>

        <p className="sdg-select-helper">
          Your SDG focus helps tailor suggestions and reporting. You can change it at any time.
        </p>
      </div>
    </div>
  );
};

export default UserSdgSelect;
